import React, { useState, useEffect, useCallback } from "react";
import SuperadminTopbar from "../../Layouts/Superadmin_layout/Superadmin_topbar";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Button,
  Pagination,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  FormHelperText,
  Typography,
  Modal,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SearchIcon from "@mui/icons-material/Search";
import { alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { FiEye } from "react-icons/fi";
import { Link } from "react-router-dom";
import { EditNote } from "@mui/icons-material";
import "../../Styles/Pages/vendors.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  border: "1px solid #79c245",
  marginRight: "10px",
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

const style = {
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  borderColor: "none",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Vendors = () => {
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editVendorId, setEditVendorId] = useState(null);

  const handleOpen = () => {
    setOpen(true);
  };
  const [companyLogo, setCompanyLogo] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setname("");
    setcompanyname("");
    setmobile_no("");
    setAlternateMobiles([]);
    setCompanyLogo(null);
    setemail("");
    setpassword("");
    setIsEditing(false);
    setnameError("");
    setEmailError("");
    setmobilenoError("");
    setcompanynameError("");
    setPasswordError("");
    setEditVendorId(null);
  };

  const token = localStorage.getItem("token");
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [vendors, setvendors] = useState([]);
  const [name, setname] = useState("");
  const [mobile_no, setmobile_no] = useState("");
  const [alternateMobiles, setAlternateMobiles] = useState([]);
  const [companyname, setcompanyname] = useState("");
  const [password, setpassword] = useState("");
  const [email, setemail] = useState("");
  const [search, setSearch] = useState("");
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [vendorStatus, setVendorStatus] = useState(null);

  const handleStatusOpen = (vendor) => {
    setOpenStatusModal(true);
    setVendorStatus(vendor);
  };

  const handleStatusClose = () => {
    setOpenStatusModal(false);
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearch(query);

    if (query === "") {
      setFilteredVendors(vendors);
    } else {
      const filtered = vendors.filter((vendor) =>
        Object.values(vendor).some((value) =>
          value !== null && value !== undefined && value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredVendors(filtered);
    }
    setCurrentPage(1);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [vendorspage] = useState(10);
  const indexOfLastvendor = currentPage * vendorspage;
  const indexOfFirstvendor = indexOfLastvendor - vendorspage;
  const currentvendors = Array.isArray(filteredVendors)
    ? filteredVendors.slice(indexOfFirstvendor, indexOfLastvendor)
    : [];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [nameError, setnameError] = useState("");
  const [mobilenoError, setmobilenoError] = useState("");
  const [companynameError, setcompanynameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const validateForm = () => {
    let isValid = true;

    if (!name) {
      setnameError("Please Enter name");
      isValid = false;
    } else {
      setnameError("");
    }
    if (!mobile_no) {
      setmobilenoError("Please Enter a Mobileno");
      isValid = false;
    } else if (!/^\d{10}$/.test(mobile_no)) {
      setmobilenoError("Please enter a valid 10-digit mobile number");
      isValid = false;
    } else {
      setmobilenoError("");
    }

    if (!companyname) {
      setcompanynameError("Please enter companyname");
      isValid = false;
    } else {
      setcompanynameError("");
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!emailRegex.test(email.toString().trim())) {
      setEmailError("Invalid email format");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!password && !isEditing) {
      setPasswordError("Please Enter a Password");
      isValid = false;
    } else {
      setPasswordError("");
    }

    return isValid;
  };

  const fetchVendors = useCallback(async () => {
    try {
      const response = await instance.get("vendor/getVendors", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // Sort vendors by createdAt descending (newest first)
      const sortedVendors = response.data.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setvendors(sortedVendors);
      setFilteredVendors(sortedVendors);
    } catch (error) {
      toast.error("Error fetching users:", error.message, { toastId: "login-error", autoClose: 5000 });
    }
  }, [token]);
  useEffect(() => {
    fetchVendors();
  }, [fetchVendors]);

  const addvendors = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("mobile_no", mobile_no);
      formData.append("companyname", companyname);
      formData.append("password", password);
      formData.append("email", email);
      if (companyLogo) {
        formData.append("company_logo", companyLogo);
      }

      const response = await instance.post(
        "vendor/signup",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        toast.success(response.data.msg, { toastId: "login-error", autoClose: 5000 });
        fetchVendors();
        handleClose();
      } else {
        toast.error("Error adding vendor: " + response.data.error, { toastId: "login-error", autoClose: 5000 });
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.error || "";

      if (errorMsg.includes("email_1")) {
        toast.error(`Email ${email} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else if (errorMsg.includes("mobile_no_1")) {
        toast.error(`Mobile Number ${mobile_no} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else if (errorMsg.includes("companyname_1")) {
        toast.error(`Company Name ${companyname} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else {
        toast.error(errorMsg || "An unexpected error occurred", { toastId: "login-error", autoClose: 5000 });
      }
      console.error("Error adding vendor:", error);
    }
  };

  const handleEditClick = (vendor) => {
    setIsEditing(true);
    setEditVendorId(vendor._id);
    setname(vendor.name);
    setmobile_no(vendor.mobile_no);
    setAlternateMobiles(vendor.alternate_mobile_numbers || []);
    setcompanyname(vendor.companyname);
    setemail(vendor.email);
    setnameError("");
    setEmailError("");
    setcompanynameError("");
    setmobilenoError("");
    handleOpen();
  };

  const updatevendors = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("mobile_no", mobile_no);
      formData.append("companyname", companyname);
      formData.append("email", email);
      formData.append("vendor_id", editVendorId);
      if (companyLogo) {
        formData.append("company_logo", companyLogo);
      }

      const response = await instance.post(
        "/vendor/updateProfile",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        toast.success(response.data.msg, { toastId: "login-error", autoClose: 5000 });
      }
      fetchVendors();
      handleClose();
    } catch (error) {
      const errorMsg = error?.response?.data?.error || "";

      if (errorMsg.includes("email_1")) {
        toast.error(`Email ${email} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else if (errorMsg.includes("mobile_no_1")) {
        toast.error(`Mobile Number ${mobile_no} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else if (errorMsg.includes("companyname_1")) {
        toast.error(`Company Name ${companyname} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else {
        toast.error(errorMsg || "An unexpected error occurred", { toastId: "login-error", autoClose: 5000 });
      }

      console.error("Error updating vendor:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing) {
      updatevendors();
    } else {
      addvendors();
    }
  };

  const [vendorDetails, setVendorDetails] = useState();

  const fetchVendorStatus = async (selectedStatus) => {
    try {
      console.log(selectedStatus);

      const newStatus = selectedStatus?.status === false ? true : false;
      const response = await instance.post("/vendor/setStatus", {
        status: newStatus,
        vendor_id: selectedStatus._id,
      });
      setVendorDetails(response.data.data.status);
      fetchVendors();
      if (response.status === 200) {
        toast.success("Status updated successfully", { toastId: "login-error", autoClose: 5000 });
      }
    } catch (err) {
      console.log(err);
    }
  };

  //api/vendor/setTracking
  const [vendorModal, setvendorModal] = useState(false);
  const [trackvendor, settrackvendor] = useState(null);

  const handlevendorOpen = (vendor) => {
    setvendorModal(true);
    settrackvendor(vendor);
  };

  const handlevendorClose = () => {
    setvendorModal(false);
    settrackvendor(null);
  };

  const fetchVendortracking = async () => {
    try {
      const response = await instance.post("/vendor/setTracking", {
        tracking: trackvendor.tracking === true ? false : true,
        vendor_id: trackvendor._id,
      });
      if (response.data.status === true) {
        toast.success(response.data.msg, { toastId: "login-error", autoClose: 5000 });
        fetchVendors();
        handlevendorClose();
      } else {
        toast.error(response.data.msg, { toastId: "login-error", autoClose: 5000 });
      }
    } catch (error) {
      toast.error(error.response.data.msg, { toastId: "login-error", autoClose: 5000 });
      console.error("Error updating tracking:", error.message);
    }
  };

  const handleChange = (e, type) => {
    let value = e.target.value;

    // Prevent leading spaces
    if (value.startsWith(" ")) return;

    // For email, prevent spaces entirely
    if (type === "email") {
      value = value.replace(/\s/g, ""); // Remove all spaces
    } else {
      // Replace multiple spaces with a single space for other fields
      value = value.replace(/\s{2,}/g, " ");
    }

    // Validate
    if (type === "name") {
      setname(value);
      setnameError(value.trim() === "" ? "Name cannot be empty" : "");
    } else if (type === "companyname") {
      setcompanyname(value);
      setcompanynameError(
        value.trim() === "" ? "Company name cannot be empty" : ""
      );
    } else if (type === "email") {
      setemail(value);
      setEmailError(value.trim() === "" ? "Email cannot be empty" : "");
    }
  };

  // Farmer Edit Permission state
  const [permissionModal, setPermissionModal] = useState(false);
  const [permissionVendor, setPermissionVendor] = useState(null);
  const [farmerEditPerm, setFarmerEditPerm] = useState(false);
  const [farmerDeletePerm, setFarmerDeletePerm] = useState(false);
  const [farmerEditStartDate, setFarmerEditStartDate] = useState('');
  const [farmerEditEndDate, setFarmerEditEndDate] = useState('');

  const handlePermissionOpen = (vendor) => {
    setPermissionVendor(vendor);
    setFarmerEditPerm(vendor.farmer_edit_permission || false);
    setFarmerDeletePerm(vendor.farmer_delete_permission || false);
    setFarmerEditStartDate(vendor.farmer_edit_start_date ? vendor.farmer_edit_start_date.split('T')[0] : '');
    setFarmerEditEndDate(vendor.farmer_edit_end_date ? vendor.farmer_edit_end_date.split('T')[0] : '');
    setPermissionModal(true);
  };

  const handlePermissionClose = () => {
    setPermissionModal(false);
    setPermissionVendor(null);
  };

  const handleSavePermission = async () => {
    try {
      const response = await instance.post('/setFarmerEditPermission', {
        vendor_id: permissionVendor._id,
        farmer_edit_permission: farmerEditPerm,
        farmer_edit_start_date: farmerEditStartDate || null,
        farmer_edit_end_date: farmerEditEndDate || null,
        farmer_delete_permission: farmerDeletePerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        toast.success("Farmer permission updated", { toastId: "perm-success", autoClose: 3000 });
        fetchVendors();
        handlePermissionClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error updating permission", { toastId: "perm-error", autoClose: 5000 });
    }
  };


  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <SuperadminTopbar />
      <div>
        <div className="officer_section">
          <BootstrapDialog
            className="sales_entry"
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              <Typography sx={{ fontFamily: "Poppins,sans-serif" }}>
                {isEditing ? "Edit Vendor" : "Add Vendor"}
              </Typography>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              <form onSubmit={handleSubmit}>
                <div className="adduser_bg">
                  <div className="user_form">
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          label="Name"
                          variant="outlined"
                          type="text"
                          value={name}
                          onChange={(e) => handleChange(e, "name")}
                          error={Boolean(nameError)}
                          required
                        />
                        <FormHelperText error={Boolean(nameError)}>
                          {nameError}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          label="Email"
                          variant="outlined"
                          type="email"
                          required
                          value={email}
                          onChange={(e) => handleChange(e, "email")}
                          error={Boolean(emailError)}
                          onKeyDown={(e) => {
                            if (e.key === " ") e.preventDefault();
                          }}
                        />
                        <FormHelperText error={Boolean(emailError)}>
                          {emailError}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          type="text"
                          required
                          label="Mobile No"
                          variant="outlined"
                          value={mobile_no}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            if (
                              /^\d*$/.test(newValue) &&
                              newValue.length <= 10
                            ) {
                              setmobile_no(newValue);
                              setmobilenoError(
                                "mobile number should be 10 digits"
                              );
                              if (newValue.length === 10) setmobilenoError("");
                            } else {
                              setmobilenoError("");
                            }
                          }}
                          onKeyDown={(e) => {
                            if (
                              !(
                                e.key >= "0" &&
                                e.key <= "9" &&
                                e.key.length === 1
                              ) &&
                              e.key !== "Backspace" &&
                              e.key !== "Tab" &&
                              e.key !== "Delete" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          error={Boolean(mobilenoError)}
                        />
                        <FormHelperText error={Boolean(mobilenoError)}>
                          {mobilenoError}
                        </FormHelperText>
                      </Grid>
                      {/* Company Logo Upload */}
                      <Grid item xs={12}>
                        <Button
                          variant="outlined"
                          component="label"
                          fullWidth
                          sx={{
                            textTransform: "none",
                            fontFamily: "Poppins,sans-serif",
                            borderColor: "#78c144",
                            color: "#78c144",
                            "&:hover": { borderColor: "#5fa030", color: "#5fa030" }
                          }}
                        >
                          Upload Company Logo (Optional)
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(e) => {
                              if (e.target.files && e.target.files[0]) {
                                setCompanyLogo(e.target.files[0]);
                              }
                            }}
                          />
                        </Button>
                        {companyLogo && (
                          <FormHelperText style={{ color: "#78c144", textAlign: "center", marginTop: 4 }}>
                            Selected: {companyLogo.name}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          required
                          id="outlined-basic"
                          label="Company Name"
                          variant="outlined"
                          type="text"
                          value={companyname}
                          onChange={(e) => handleChange(e, "companyname")}
                          error={Boolean(companynameError)}
                        />
                        <FormHelperText error={Boolean(companynameError)}>
                          {companynameError}
                        </FormHelperText>
                      </Grid>
                      {isEditing ? (
                        ""
                      ) : (
                        <Grid item xs={12}>
                          <TextField
                            required
                            id="outlined-basic"
                            label="Password"
                            variant="outlined"
                            type="password"
                            value={password}
                            onChange={(e) => {
                              setpassword(e.target.value);
                              setPasswordError("");
                            }}
                            error={Boolean(passwordError)}
                          />
                          <FormHelperText error={Boolean(passwordError)}>
                            {passwordError}
                          </FormHelperText>
                        </Grid>
                      )}
                    </Grid>
                  </div>
                </div>
                <div className="cancel_save_user">
                  <Button className="cancel" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    className="save_user"
                    onClick={isEditing ? updatevendors : addvendors}
                  >
                    {isEditing ? "Update" : "Add"}
                  </Button>
                </div>
              </form>
            </DialogContent>
          </BootstrapDialog>
          <section className="main_box">
            <div className="container-fluid">
              <div className="table_box">
                <TableContainer component={Paper}>
                  <div className="table_inbox">
                    <div className="add_user_list">
                      <div className="add_user_content">
                        <div
                          style={{
                            fontFamily: "Poppins,sans-serif",
                            fontSize: "20px",
                            fontWeight: "bold",
                          }}
                        >
                          Vendors
                        </div>
                      </div>
                      <div className="add_user">
                        <div>
                          <Search>
                            <SearchIconWrapper>
                              <SearchIcon />
                            </SearchIconWrapper>
                            <StyledInputBase
                              type="search"
                              placeholder="Search…"
                              inputProps={{ "aria-label": "search" }}
                              value={search}
                              onChange={handleSearch}
                            />
                          </Search>
                        </div>
                        <Button variant="outlined" onClick={handleOpen}>
                          Add Vendors
                        </Button>
                      </div>
                    </div>
                    <Table
                      className="adduser_table user_table product_table"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow className="table_head">
                          <TableCell align="center" className="first-child">
                            Sl.No
                          </TableCell>
                          <TableCell align="center" className="second-child">
                            Vendor Name
                          </TableCell>
                          <TableCell align="center">Company Name</TableCell>
                          <TableCell align="center" className="third-child">
                            Email
                          </TableCell>
                          <TableCell align="center">Mobile No</TableCell>
                          <TableCell align="center">Status</TableCell>
                          <TableCell align="center">Tracking</TableCell>
                          <TableCell align="center">Manage</TableCell>
                          <TableCell align="center">View All Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="table_body">
                        {currentvendors.length > 0 ? (
                          currentvendors.map((vendor, index) => (
                            <TableRow key={vendor._id}>
                              <TableCell align="center">
                                {index + 1 + (currentPage - 1) * vendorspage}
                              </TableCell>
                              <TableCell align="center">
                                {vendor.name}
                              </TableCell>
                              <TableCell align="center">
                                {vendor.companyname}
                              </TableCell>
                              <TableCell align="center">
                                {vendor.email}
                              </TableCell>
                              <TableCell align="center">
                                {vendor.mobile_no}
                              </TableCell>
                              <TableCell>
                                <button
                                  className={`vendors-status ${vendor.status === false
                                    ? "inactive"
                                    : "active"
                                    }`}
                                  onClick={() => handleStatusOpen(vendor)}
                                >
                                  {vendor.status === false
                                    ? "Inactive"
                                    : "Active"}
                                </button>
                              </TableCell>
                              <TableCell>
                                <button
                                  className={`vendors-status ${vendor.tracking === false
                                    ? "inactive"
                                    : "active"
                                    }`}
                                  onClick={() => handlevendorOpen(vendor)}
                                >
                                  {vendor.tracking === true
                                    ? "Active"
                                    : "Inactive"}
                                </button>
                              </TableCell>
                              <TableCell align="center">
                                <div className="farmer-details">
                                  <EditNote
                                    onClick={() => handleEditClick(vendor)}
                                    className="view-icon"
                                  />
                                </div>
                              </TableCell>
                              <TableCell align="center">
                                <Link
                                  className="farmer-details"
                                  to={`/superadmin/AllDetails/${vendor._id}`}
                                >
                                  <FiEye className="view-icon" />
                                </Link>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableCell colSpan={12} align="center">
                            <Typography>No matched items</Typography>
                          </TableCell>
                        )}
                      </TableBody>
                    </Table>
                    <div className="pagination_table">
                      <Pagination
                        count={Math.ceil(filteredVendors.length / vendorspage)}
                        page={currentPage}
                        onChange={(event, page) => paginate(page)}
                        shape="rounded"
                        variant="outlined"
                      />
                    </div>
                  </div>
                </TableContainer>
                <Modal
                  open={openStatusModal}
                  onClose={handleStatusClose}
                  aria-labelledby="delete-modal-title"
                  aria-describedby="delete-modal-description"
                >
                  <Box sx={style}>
                    <div id="delete-modal-title">
                      {`Do you want to mark ${vendorStatus?.name} as ${vendorStatus?.status ? "inactive" : "active"
                        } ?`}
                    </div>
                    <div id="delete-modal-description">
                      <Button
                        variant="contained"
                        className="yes"
                        onClick={() => {
                          fetchVendorStatus(vendorStatus);
                          setOpenStatusModal(false);
                        }}
                      >
                        Yes
                      </Button>
                      <Button
                        variant="contained"
                        className="no"
                        onClick={handleStatusClose}
                      >
                        No
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <div>
                  <Modal
                    open={vendorModal}
                    onClose={handlevendorClose}
                    aria-labelledby="delete-modal-title"
                    aria-describedby="delete-modal-description"
                  >
                    <Box sx={style}>
                      <div id="delete-modal-title">
                        {`Do you want to mark ${trackvendor?.name} as ${trackvendor?.tracking ? "Inactive" : "Active"
                          } ?`}
                      </div>
                      <div id="delete-modal-description">
                        <Button
                          variant="contained"
                          className="yes"
                          onClick={() => fetchVendortracking()}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          className="no"
                          onClick={handlevendorClose}
                        >
                          No
                        </Button>
                      </div>
                    </Box>
                  </Modal>
                </div>

                {/* Farmer Edit Permission Modal */}
                <Modal
                  open={permissionModal}
                  onClose={handlePermissionClose}
                >
                  <Box sx={{ ...style, width: 450 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', fontFamily: 'Poppins,sans-serif' }}>
                      Farmer Edit Permission - {permissionVendor?.name}
                    </Typography>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontFamily: 'Poppins,sans-serif' }}>
                        <input
                          type="checkbox"
                          checked={farmerEditPerm}
                          onChange={(e) => setFarmerEditPerm(e.target.checked)}
                          style={{ width: 18, height: 18 }}
                        />
                        Allow Field Officers to Edit Farmers
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontFamily: 'Poppins,sans-serif' }}>
                        <input
                          type="checkbox"
                          checked={farmerDeletePerm}
                          onChange={(e) => setFarmerDeletePerm(e.target.checked)}
                          style={{ width: 18, height: 18 }}
                        />
                        Allow Field Officers to Delete Farmers
                      </label>
                      <div>
                        <Typography sx={{ fontSize: '14px', fontFamily: 'Poppins,sans-serif', mb: 0.5 }}>
                          Edit Allowed From:
                        </Typography>
                        <input
                          type="date"
                          value={farmerEditStartDate}
                          onChange={(e) => setFarmerEditStartDate(e.target.value)}
                          style={{ padding: '8px 12px', borderRadius: 4, border: '1px solid #ccc', width: '100%', fontFamily: 'Poppins,sans-serif' }}
                        />
                      </div>
                      <div>
                        <Typography sx={{ fontSize: '14px', fontFamily: 'Poppins,sans-serif', mb: 0.5 }}>
                          Edit Allowed Until:
                        </Typography>
                        <input
                          type="date"
                          value={farmerEditEndDate}
                          onChange={(e) => setFarmerEditEndDate(e.target.value)}
                          style={{ padding: '8px 12px', borderRadius: 4, border: '1px solid #ccc', width: '100%', fontFamily: 'Poppins,sans-serif' }}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 20 }}>
                      <Button variant="outlined" onClick={handlePermissionClose}>Cancel</Button>
                      <Button variant="contained" onClick={handleSavePermission} sx={{ background: '#78c144', '&:hover': { background: '#5fa030' } }}>
                        Save
                      </Button>
                    </div>
                  </Box>
                </Modal>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Vendors;
